
(() => {
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const sleep = ms => new Promise(r => setTimeout(r, ms));
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const cap = s => s[0].toUpperCase() + s.slice(1);

const I = {
  up: '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M6 11l6-6 6 6"/></svg>',
  stop: '<svg width="13" height="13" viewBox="0 0 12 12"><rect width="12" height="12" rx="3" fill="currentColor"/></svg>',
  rod: s => `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5v19"/><circle cx="12" cy="3.4" r=".9" fill="currentColor"/><path d="M14.8 6.2c0-1.1-1.2-1.8-2.8-1.8s-3 .8-3 2 1.4 1.8 3 2.1 3.2.9 3.2 2.4-1.4 2.2-3.2 2.4-3.2.8-3.2 2.2 1.3 2 3 2.2 2.6.7 2.6 1.6"/></svg>`,
  copy: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v1"/></svg>',
  redo: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 11-2.6-6.4L21 8"/><path d="M21 3v5h-5"/></svg>',
  good: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v11H4a1 1 0 01-1-1v-9a1 1 0 011-1h3zm0 0l4-8a2.5 2.5 0 012.5 2.5V8h5.3a2 2 0 012 2.3l-1.4 9A2 2 0 0117.4 21H7"/></svg>',
  bad: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 14V3h3a1 1 0 011 1v9a1 1 0 01-1 1h-3zm0 0l-4 8a2.5 2.5 0 01-2.5-2.5V16H5.2a2 2 0 01-2-2.3l1.4-9A2 2 0 016.6 3H17"/></svg>',
  tick: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  phone: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 01-2.2 2 19.8 19.8 0 01-8.6-3.1 19.5 19.5 0 01-6-6A19.8 19.8 0 012.1 4.2 2 2 0 014.1 2h3a2 2 0 012 1.7c.1.9.4 1.8.7 2.7a2 2 0 01-.5 2.1L8 9.8a16 16 0 006 6l1.3-1.3a2 2 0 012.1-.4c.9.3 1.8.6 2.7.7a2 2 0 011.7 2z"/></svg>',
  tip: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 21h4M12 3a6 6 0 00-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0012 3z"/></svg>',
  warn: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"/><path d="M12 9v4M12 17h.01"/></svg>',
  steth: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3v5a4 4 0 008 0V3"/><path d="M10 12v3a5 5 0 0010 0v-2"/><circle cx="20" cy="11" r="2"/></svg>',
  book: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19V5a2 2 0 012-2h13v18H6a2 2 0 01-2-2zm0 0a2 2 0 012-2h13"/></svg>',
  heart: '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-9.6-9.5C.9 8 3 4 6.8 4c2.2 0 3.6 1.2 5.2 3 1.6-1.8 3-3 5.2-3C21 4 23.1 8 21.6 11.5 19.5 16.4 12 21 12 21z"/></svg>'
};

/* ---------- Regions ---------- */
const REGIONS = {
  AU: { name: 'Australia', num: '000', para: 'paracetamol', temp: '36.1 to 37.2 °C', colour: 'Colour' },
  US: { name: 'United States', num: '911', para: 'acetaminophen', temp: '97 to 99 °F', colour: 'Color' },
  UK: { name: 'United Kingdom', num: '999', para: 'paracetamol', temp: '36.1 to 37.2 °C', colour: 'Colour' },
  CA: { name: 'Canada', num: '911', para: 'acetaminophen', temp: '36.1 to 37.2 °C', colour: 'Colour' },
  NZ: { name: 'New Zealand', num: '111', para: 'paracetamol', temp: '36.1 to 37.2 °C', colour: 'Colour' },
  EU: { name: 'European Union', num: '112', para: 'paracetamol', temp: '36.1 to 37.2 °C', colour: 'Colour' },
  IN: { name: 'India', num: '112', para: 'paracetamol', temp: '36.1 to 37.2 °C', colour: 'Colour' }
};
let regionKey = 'AU', R = REGIONS.AU, audience = 'patient';
function renderRegionMenu() {
  $('#regionMenu').innerHTML = Object.entries(REGIONS).map(([k, r]) => `<button role="menuitemradio" aria-checked="${k === regionKey}" data-r="${k}">${r.name}<b>${r.num}</b></button>`).join('') + '<p class="menu-note">Sets the emergency number and medicine names used in answers.</p>';
  $$('#regionMenu button').forEach(b => b.addEventListener('click', () => { setRegion(b.dataset.r); closeMenu(); }));
}
function setRegion(k) {
  regionKey = k; R = REGIONS[k];
  $('#emergNum').textContent = R.num; $('#fineNum').textContent = R.num;
  renderRegionMenu(); renderTiles(); if (selRegion) selectRegion(selRegion);
}
const closeMenu = () => { $('#regionMenu').classList.remove('open'); $('#emergBtn').setAttribute('aria-expanded', 'false'); };
$('#emergBtn').addEventListener('click', e => { e.stopPropagation(); const o = $('#regionMenu').classList.toggle('open'); $('#emergBtn').setAttribute('aria-expanded', o); });
document.addEventListener('click', e => { if (!e.target.closest('.emerg-wrap')) closeMenu(); });

/* ---------- ECG composer line ---------- */
const ECG = (() => {
  const cv = $('#ecg'), c = cv.getContext('2d');
  let W = 0, H = 28, buf = [], x = 0, phase = 0, acc = 0, last = performance.now(), mode = 'idle';
  const CFG = { idle: { period: 1150, amp: .36, speed: 80, color: 'rgba(11,122,117,.75)' }, busy: { period: 520, amp: .46, speed: 150, color: '#F0544F' } };
  const g = (p, m, s, a) => a * Math.exp(-((p - m) ** 2) / (2 * s * s));
  const wave = p => g(p, .16, .028, .12) + g(p, .285, .009, -.12) + g(p, .31, .011, 1) + g(p, .335, .01, -.3) + g(p, .55, .045, .24);
  function resize() {
    const r = cv.getBoundingClientRect(), d = Math.min(2, devicePixelRatio || 1);
    W = Math.max(1, Math.round(r.width)); H = r.height || 28;
    cv.width = W * d; cv.height = H * d; c.setTransform(d, 0, 0, d, 0, 0);
    buf = new Array(W).fill(0); x = 0;
    if (reduce) { for (let i = 0; i < W; i++) buf[i] = wave((i / 90) % 1); draw(true); }
  }
  function draw(stat) {
    const k = CFG[mode], mid = H / 2, gap = stat ? 0 : 18;
    c.clearRect(0, 0, W, H); c.lineWidth = 1.7; c.lineJoin = 'round'; c.strokeStyle = k.color;
    c.beginPath();
    let started = false;
    for (let n = gap; n < W; n++) {
      const i = (x + n) % W, y = mid - buf[i] * H * k.amp;
      if (!started || i === 0) { c.moveTo(i, y); started = true; } else c.lineTo(i, y);
    }
    c.stroke();
    if (!stat) { const hx = (x - 1 + W) % W, hy = mid - buf[hx] * H * k.amp; c.fillStyle = k.color; c.shadowColor = k.color; c.shadowBlur = 8; c.beginPath(); c.arc(hx, hy, 2.3, 0, Math.PI * 2); c.fill(); c.shadowBlur = 0; }
  }
  function frame(now) {
    const k = CFG[mode], dt = Math.min(64, now - last); last = now;
    acc += k.speed * dt / 1000;
    while (acc >= 1) { acc--; phase += (1000 / k.speed) / k.period; buf[x] = wave(phase % 1); x = (x + 1) % W; }
    draw(false); requestAnimationFrame(frame);
  }
  new ResizeObserver(resize).observe(cv);
  if (!reduce) requestAnimationFrame(frame);
  return { set(m) { mode = m; if (reduce) draw(true); } };
})();

/* ---------- Tiles ---------- */
const TILE_ICON = {
  pill: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><rect x="3" y="8" width="18" height="8" rx="4" transform="rotate(-40 12 12)"/><path d="M9.3 8.8l5.4 6.4" transform="rotate(0)"/></svg>',
  scalpel: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21l8-8M11 13l9-9c1 3 0 6-3 8l-3 2z"/></svg>',
  alert: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17h.01"/></svg>',
  heart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20s-7-4.3-9-9C1.7 7.6 3.8 4 7.3 4c2 0 3.3 1.1 4.7 2.8C13.4 5.1 14.7 4 16.7 4 20.2 4 22.3 7.6 21 11c-2 4.7-9 9-9 9z"/></svg>'
};
const tileData = () => [
  ['Medicines', '#0B7A75', '#E2F2F0', 'pill', `Can I take ibuprofen and ${R.para} together?`],
  ['Procedures', '#2563B0', '#E8F0FB', 'scalpel', 'How long does knee replacement recovery take?'],
  ['Emergencies', '#D92D20', '#FDECEA', 'alert', 'What are the warning signs of a stroke?'],
  ['Wellness', '#1E7D52', '#E6F4EC', 'heart', 'What is a normal resting heart rate?']
];
function renderTiles() {
  const d = tileData();
  $('#tiles').innerHTML = d.map(([cat, c, t, ic, q], i) => `<button class="tile" data-i="${i}" style="--c:${c};--t:${t}"><span class="tile-cat"><span>${TILE_ICON[ic]}</span>${cat}</span><span class="tile-q">${q}</span></button>`).join('');
  $$('.tile').forEach(b => b.addEventListener('click', () => send(d[b.dataset.i][4])));
}

/* ---------- Body map ---------- */
const HOTSPOTS = {
  head:    { x: 150, y: 50,  name: 'Head and brain', organs: ['brain'], prompts: () => ['What are the warning signs of a stroke?', 'How should I describe my symptoms?'] },
  chest:   { x: 160, y: 206, name: 'Heart and chest', organs: ['heart', 'lungL', 'lungR'], prompts: () => ['What are the warning signs of a heart attack?', 'What is a normal resting heart rate?'] },
  abdomen: { x: 150, y: 292, name: 'Abdomen', organs: ['liver', 'stomach', 'gut'], prompts: () => ['When is abdominal pain an emergency?', `Can I take ibuprofen and ${R.para} together?`] },
  skin:    { x: 230, y: 196, name: 'Skin', organs: ['armSkin'], prompts: () => ["What should I know about a mole that's changed?", 'How should I describe my symptoms?'] },
  wrist:   { x: 58,  y: 318, name: 'Pulse and circulation', organs: ['wristRing'], prompts: () => ['How do I check my pulse?', 'What is a normal resting heart rate?'] },
  knee:    { x: 178, y: 458, name: 'Joints and bones', organs: ['kneeL', 'kneeR'], prompts: () => ['How long does knee replacement recovery take?', `Can I take ibuprofen and ${R.para} together?`] }
};
let selRegion = null;
function renderBody() {
  const limbs = [[90, 146, 70, 244], [70, 244, 58, 336], [210, 146, 230, 244], [230, 244, 242, 336], [128, 330, 122, 458], [122, 458, 120, 570], [172, 330, 178, 458], [178, 458, 180, 570]];
  const torso = 'M104 124Q150 110 196 124Q214 130 214 150L206 250Q199 292 204 334Q150 356 96 334Q101 292 94 250L86 150Q86 130 104 124Z';
  const layer = (fill, outline) => `${limbs.map(([a, b, c, d]) => `<line x1="${a}" y1="${b}" x2="${c}" y2="${d}" stroke="${outline ? '#C4D7D3' : fill}" stroke-width="${outline ? 29 : 25}" stroke-linecap="round"/>`).join('')}
    <path d="${torso}" fill="${fill}" ${outline ? 'stroke="#C4D7D3" stroke-width="4"' : ''}/>
    <ellipse cx="150" cy="58" rx="33" ry="40" fill="${fill}" ${outline ? 'stroke="#C4D7D3" stroke-width="4"' : ''}/>
    <rect x="136" y="90" width="28" height="40" rx="10" fill="${fill}" ${outline ? 'stroke="#C4D7D3" stroke-width="4"' : ''}/>`;
  const hs = Object.entries(HOTSPOTS).map(([k, h]) => `<g class="hs" data-k="${k}" tabindex="0" role="button" aria-label="${h.name}"><circle class="ring" cx="${h.x}" cy="${h.y}" r="9"/><circle class="dot" cx="${h.x}" cy="${h.y}" r="9"/><circle class="core" cx="${h.x}" cy="${h.y}" r="3.2"/></g>`).join('');
  $('#bodymap').innerHTML = `
    <svg viewBox="0 0 300 600" role="img" aria-label="Body map. Choose an area of the body.">
      <defs>
        <linearGradient id="skinG" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="600"><stop offset="0" stop-color="#E4F1EE"/><stop offset="1" stop-color="#F6FAF9"/></linearGradient>
        <linearGradient id="scanG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0B7A75" stop-opacity="0"/><stop offset=".85" stop-color="#0B7A75" stop-opacity=".28"/><stop offset="1" stop-color="#0B7A75" stop-opacity=".7"/></linearGradient>
        <mask id="bodyMask">${layer('#fff', false)}</mask>
        <filter id="soft" x="-20%" y="-10%" width="140%" height="130%"><feDropShadow dx="0" dy="14" stdDeviation="14" flood-color="#0F2A2E" flood-opacity=".12"/></filter>
      </defs>
      <g filter="url(#soft)">${layer('#C4D7D3', true)}${layer('url(#skinG)', false)}</g>
      <g mask="url(#bodyMask)"><rect class="scanbar" x="0" y="0" width="300" height="70" fill="url(#scanG)"/></g>
      <line id="armSkin" class="organ" x1="210" y1="146" x2="230" y2="244" stroke-width="22" style="stroke-opacity:0;stroke-width:22px"/>
      <path id="brain" class="organ" d="M128 56c-6-16 6-28 18-26 6-8 20-6 24 4 14 2 18 18 8 26 2 10-10 16-20 12-6 6-18 4-20-4-8 0-12-6-10-12zM150 33c-3 8 3 14 0 22s3 12 0 20"/>
      <path class="organ" d="M150 116v30M150 144l-9 9M150 144l9 9"/>
      <path id="lungL" class="organ" d="M140 152c-20 2-33 22-35 50-2 26 2 42 12 48 12 6 24 0 26-12 3-30 1-58-3-86z"/>
      <path id="lungR" class="organ" d="M160 152c20 2 33 22 35 50 2 26-2 42-12 48-12 6-24 0-26-12-3-30-1-58 3-86z"/>
      <path id="heart" d="M160 224c-3-2-21-12-21-26 0-8 6-13 12-13 4 0 7 2 9 5 2-3 5-5 9-5 6 0 12 5 12 13 0 14-18 24-21 26z"/>
      <path id="liver" class="organ" d="M104 258c10-12 44-14 64-6-4 14-18 24-36 26-16 2-28-6-28-20z"/>
      <path id="stomach" class="organ" d="M170 254c16-6 30 2 30 16 0 18-16 30-32 30-10 0-18-6-18-14 10 0 18-6 18-16 0-6 1-12 2-16z"/>
      <path id="gut" class="organ" d="M116 310q8-10 16 0t16 0t16 0t16 0t16 0M120 328q8-10 16 0t16 0t16 0t16 0"/>
      <circle id="wristRing" class="organ" cx="58" cy="318" r="14"/>
      <circle id="kneeL" class="organ" cx="122" cy="458" r="13"/>
      <circle id="kneeR" class="organ" cx="178" cy="458" r="13"/>
      <g class="callout" id="callout" style="display:none"><line/><rect rx="8" height="26"/><text/></g>
      ${hs}
    </svg>`;
  $$('.hs').forEach(g => {
    g.addEventListener('mouseenter', () => highlight(g.dataset.k));
    g.addEventListener('mouseleave', () => highlight(selRegion));
    g.addEventListener('focus', () => highlight(g.dataset.k));
    g.addEventListener('blur', () => highlight(selRegion));
    g.addEventListener('click', () => selectRegion(g.dataset.k));
    g.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectRegion(g.dataset.k); } });
  });
  renderRegion();
}
function highlight(k) {
  $$('#bodymap .organ, #heart').forEach(o => o.classList.remove('on'));
  $('#armSkin').style.strokeOpacity = 0;
  const co = $('#callout');
  if (!k) { co.style.display = 'none'; return; }
  const h = HOTSPOTS[k];
  h.organs.forEach(id => { const o = $('#' + id); if (o) o.classList.add('on'); });
  if (k === 'skin') $('#armSkin').style.strokeOpacity = .5;
  const right = h.x >= 150, w = h.name.length * 7.1 + 20, lx = right ? 296 - w : 4;
  co.style.display = '';
  const line = co.querySelector('line'), rect = co.querySelector('rect'), text = co.querySelector('text');
  const ly = h.y < 40 ? h.y + 24 : h.y - 22;
  line.setAttribute('x1', h.x); line.setAttribute('y1', h.y); line.setAttribute('x2', right ? lx : lx + w); line.setAttribute('y2', ly + 13);
  rect.setAttribute('x', lx); rect.setAttribute('y', ly); rect.setAttribute('width', w);
  text.setAttribute('x', lx + 10); text.setAttribute('y', ly + 17.5); text.textContent = h.name;
}
function selectRegion(k) {
  selRegion = k;
  $$('.hs').forEach(g => g.classList.toggle('sel', g.dataset.k === k));
  highlight(k); renderRegion();
}
function renderRegion() {
  const el = $('#region');
  if (!selRegion) { el.innerHTML = `<div class="region-h"><b>Choose an area of the body</b>You'll get questions to start with for that area.</div>`; return; }
  const h = HOTSPOTS[selRegion], p = h.prompts();
  el.innerHTML = `<div class="region-h"><b>${h.name}</b>Start with one of these questions</div><div class="region-prompts">${p.map(q => `<button>${q}</button>`).join('')}</div>`;
  el.querySelectorAll('button').forEach((b, i) => b.addEventListener('click', () => send(p[i])));
}

/* ---------- Production medical response levels ---------- */
const LEVELS = {
  emergency: { rank: 5, label: 'Emergency', c: '#D92D20', t: '#FDECEA' },
  urgent: { rank: 4, label: 'Extra caution', c: '#C2410C', t: '#FFF1E6' },
  routine: { rank: 3, label: 'Medical information', c: '#9A6700', t: '#FFF6DF' },
  planned: { rank: 2, label: 'Planned care', c: '#2563B0', t: '#E8F0FB' },
  info: { rank: 1, label: 'General information', c: '#1E7D52', t: '#E6F4EC' }
};

/* ---------- Summary ---------- */
const S = { top: null, topics: [], meds: [], qs: [], src: [] };
function updateSummary(p) {
  if (p.topic === 'Getting started') return;
  const L = LEVELS[p.level];
  if (!S.top || L.rank >= LEVELS[S.top.level].rank) S.top = { level: p.level, text: p.triageText };
  S.topics.push({ name: p.topic, level: p.level, time: new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) });
  p.meds.forEach(m => { if (!S.meds.includes(m)) S.meds.push(m); });
  p.questions.forEach(q => { if (!S.qs.find(x => x.q === q)) S.qs.push({ q, done: false }); });
  p.sources.forEach(s => { if (!S.src.includes(s)) S.src.push(s); });
  renderSummary();
}
function renderSummary() {
  const tri = $('#sTriage');
  if (S.top) { const L = LEVELS[S.top.level]; tri.style.setProperty('--c', L.c); tri.style.setProperty('--t', L.t); tri.innerHTML = `<b>${L.label}</b><p>${S.top.text}</p>`; }
  else { tri.removeAttribute('style'); tri.innerHTML = `<b>Nothing assessed yet</b><p>Ask a question and the most urgent advice will show here.</p>`; }
  $('#sTopics').innerHTML = S.topics.length ? S.topics.map(t => `<div class="topic" style="--c:${LEVELS[t.level].c}"><i></i><span>${t.name}</span><small>${t.time}</small></div>`).join('') : '<p class="empty-line">No topics yet</p>';
  $('#sMeds').innerHTML = S.meds.length ? S.meds.map(m => `<span class="pill-tag">${m}</span>`).join('') : '<p class="empty-line">None yet</p>';
  $('#sQs').innerHTML = S.qs.length ? S.qs.map((q, i) => `<button class="q-item" role="checkbox" aria-checked="${q.done}" data-i="${i}"><span class="bx">${I.tick}</span><span>${q.q}</span></button>`).join('') : '<p class="empty-line">Suggested questions will collect here</p>';
  $$('#sQs .q-item').forEach(b => b.addEventListener('click', () => { const q = S.qs[b.dataset.i]; q.done = !q.done; b.setAttribute('aria-checked', q.done); }));
  $('#sSrc').innerHTML = S.src.length ? S.src.map(s => `<div class="src">${I.book}${s}</div>`).join('') : '<p class="empty-line">None yet</p>';
  $('#sumBadge').textContent = S.qs.length ? S.qs.length : '';
}
$('#sumCopy').addEventListener('click', () => {
  if (!S.topics.length) { toast('Ask a question first to build your summary'); return; }
  const lines = [`Visit summary, ${new Date().toLocaleDateString()}`, '', `Urgency: ${LEVELS[S.top.level].label}. ${S.top.text}`, '', 'Topics:', ...S.topics.map(t => `- ${t.name}`)];
  if (S.meds.length) lines.push('', `Medicines mentioned: ${S.meds.join(', ')}`);
  lines.push('', 'Questions for my doctor:', ...S.qs.map(q => `- ${q.q}`), '', 'General health information from Rounds, not a diagnosis.');
  copyText(lines.join('\n'), 'Summary copied');
});

/* ---------- Chat engine ---------- */
const app = $('#app'), scroll = $('#scroll'), thread = $('#thread'), input = $('#input'), sendBtn = $('#send');
let busy = false, gen = 0, stick = true;
function follow() { if (stick) scroll.scrollTop = scroll.scrollHeight; }
scroll.addEventListener('scroll', () => { stick = scroll.scrollHeight - scroll.scrollTop - scroll.clientHeight < 90; });
function setSend() { sendBtn.innerHTML = busy ? I.stop : I.up; sendBtn.setAttribute('aria-label', busy ? 'Stop' : 'Send'); sendBtn.disabled = !busy && !input.value.trim(); }
function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight, 220) + 'px'; setSend(); }
function toast(msg) { const t = $('#toast'); t.textContent = msg; t.classList.add('show'); clearTimeout(toast.t); toast.t = setTimeout(() => t.classList.remove('show'), 1900); }
function copyText(txt, ok = 'Copied to clipboard') { (navigator.clipboard ? navigator.clipboard.writeText(txt) : Promise.reject()).then(() => toast(ok), () => toast('Copy is blocked in this browser')); }

const HIST = { today: [], week: [] };
function histBtn([title, level]) {
  const b = document.createElement('button'); b.className = 'hist'; b.style.setProperty('--c', LEVELS[level].c);
  b.innerHTML = '<i></i><span></span>'; b.querySelector('span').textContent = title; b.title = title;
  b.addEventListener('click', () => { newChat(); send(title); });
  return b;
}
HIST.today.forEach(h => $('#hToday').appendChild(histBtn(h)));
HIST.week.forEach(h => $('#hWeek').appendChild(histBtn(h)));

function startChat(title, level) {
  if (app.classList.contains('started')) return;
  app.classList.add('started');
  $('#dockBottom').appendChild($('#composer'));
  $$('.hist.active').forEach(h => h.classList.remove('active'));
  const b = histBtn([title.length > 40 ? title.slice(0, 38) + '…' : title, level]); b.classList.add('active');
  $('#hToday').prepend(b);
}
function newChat() {
  gen++; busy = false; ECG.set('idle'); thread.innerHTML = '';
  app.classList.remove('started', 'hist-open', 'sum-open');
  $('#railHist').setAttribute('aria-pressed', 'false');
  $('#dockHome').appendChild($('#composer'));
  $$('.hist.active').forEach(h => h.classList.remove('active'));
  Object.assign(S, { top: null, topics: [], meds: [], qs: [], src: [] }); renderSummary();
  input.value = ''; autosize(); scroll.scrollTop = 0;
  if (matchMedia('(pointer:fine)').matches) input.focus();
}
function addUser(text) {
  const m = document.createElement('div'); m.className = 'msg user';
  const b = document.createElement('div'); b.className = 'bubble'; b.textContent = text;
  m.appendChild(b); thread.appendChild(m);
}
function aiShell(p) {
  const wrap = document.createElement('div'); wrap.className = 'msg ai';
  const L = LEVELS[p.level];
  wrap.innerHTML = `<div class="ai-av">${I.rod(20)}</div><div><div class="ai-head"><b>Maya</b>${p.topic !== 'Getting started' ? `<span class="tri" style="--c:${L.c};--t:${L.t}">${L.label}</span>` : ''}${audience === 'clinician' ? '<span class="mode-tag">Clinician mode</span>' : ''}</div><div class="ai-body"></div></div>`;
  thread.appendChild(wrap);
  return { wrap, body: wrap.querySelector('.ai-body') };
}
function monitor(body, steps) {
  const el = document.createElement('div'); el.className = 'monitor';
  const wave = 'M0 14H14L17 12L20 14H24L26 16L29 3L32 23L35 14H42Q46 8 50 14H60';
  el.innerHTML = `<svg width="120" height="28" viewBox="0 0 120 28" aria-hidden="true"><g class="wave">${[0, 60, 120, 180].map(x => `<path d="${wave}" transform="translate(${x} 0)" fill="none" stroke="#F0544F" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>`).join('')}</g></svg><span></span>`;
  body.appendChild(el);
  let k = 0; const label = el.querySelector('span'); label.textContent = steps[0];
  const t = setInterval(() => { label.textContent = steps[++k % steps.length]; }, 800);
  follow();
  return { stop() { clearInterval(t); el.remove(); } };
}
async function stream(el, html, id) {
  const parts = html.split(/(\s+)/); let acc = '';
  for (const part of parts) {
    if (id !== gen) return;
    acc += part;
    if (part.trim()) { el.innerHTML = acc; follow(); if (!reduce) await sleep(10 + Math.random() * 15); }
  }
  el.innerHTML = html;
}
async function renderBlock(body, b, id) {
  if (b.t === 'p' || b.t === 'h') {
    const el = document.createElement(b.t === 'h' ? 'h3' : 'p'); body.appendChild(el); await stream(el, b.h, id);
  } else if (b.t === 'note') {
    const el = document.createElement('div'); el.className = `note ${b.kind}`;
    el.innerHTML = `${I[b.kind === 'clin' ? 'steth' : b.kind]}<div></div>`; body.appendChild(el);
    await stream(el.querySelector('div'), b.h, id);
  } else if (b.t === 'ul' || b.t === 'ol' || b.t === 'flags') {
    const list = document.createElement(b.t === 'ol' ? 'ol' : 'ul'); if (b.t === 'flags') list.className = 'flags'; body.appendChild(list);
    for (const it of b.items) { if (id !== gen) return; const li = document.createElement('li'); list.appendChild(li); await stream(li, it, id); }
  } else if (b.t === 'node') {
    body.appendChild(b.make()); follow(); if (!reduce) await sleep(480);
  } else if (b.t === 'chips') {
    const c = document.createElement('div'); c.className = 'chips reveal';
    b.items.forEach(q => { const bt = document.createElement('button'); bt.textContent = q; bt.addEventListener('click', () => send(q)); c.appendChild(bt); });
    body.appendChild(c);
  }
  follow();
}
function finish(wrap, body, text) {
  const d = document.createElement('div'); d.className = 'disclaim reveal';
  d.innerHTML = `${I.steth.replace('width="20" height="20"', 'width="17" height="17"')}<span>General health information, not a diagnosis. If you're worried, talk to a doctor or pharmacist.</span>`;
  body.appendChild(d);
  const a = document.createElement('div'); a.className = 'actions reveal';
  a.innerHTML = `<button class="icon-btn sm" data-a="copy" aria-label="Copy answer">${I.copy}</button><button class="icon-btn sm" data-a="redo" aria-label="Regenerate answer">${I.redo}</button><button class="icon-btn sm" data-a="good" aria-label="Helpful" aria-pressed="false">${I.good}</button><button class="icon-btn sm" data-a="bad" aria-label="Not helpful" aria-pressed="false">${I.bad}</button>`;
  body.appendChild(a);
  a.addEventListener('click', e => {
    const btn = e.target.closest('button'); if (!btn) return;
    const act = btn.dataset.a;
    if (act === 'copy') copyText([...body.children].filter(c => c !== a && !c.classList.contains('chips')).map(c => c.innerText).join('\n\n'));
    else if (act === 'redo') { if (busy) return; wrap.remove(); stick = true; generate(text, true); }
    else { const on = btn.getAttribute('aria-pressed') !== 'true'; a.querySelectorAll('[data-a="good"],[data-a="bad"]').forEach(x => x.setAttribute('aria-pressed', 'false')); btn.setAttribute('aria-pressed', on); if (on) toast('Thanks for the feedback'); }
  });
}
let pendingDocuments = [];
function uiLevel(packet) {
  if (packet?.safety?.mustEscalate) return 'emergency';
  if (packet?.safety?.disposition === 'urgent-caution') return 'urgent';
  if (packet?.route?.intent === 'procedure') return 'planned';
  if (['lab','condition','symptom','imaging'].includes(packet?.route?.intent)) return 'routine';
  return 'info';
}
function displayTopic(packet) {
  const intent = packet?.route?.intent || 'medical information';
  return intent.split('-').map(x => x ? x[0].toUpperCase() + x.slice(1) : x).join(' ');
}
function appendInline(parent, text, evidenceMap) {
  const re = /(\*\*[^*]+\*\*|\[S\d+\])/g; let last = 0, m;
  while ((m = re.exec(text))) {
    if (m.index > last) parent.appendChild(document.createTextNode(text.slice(last, m.index)));
    const token = m[0];
    if (token.startsWith('**')) { const strong = document.createElement('strong'); strong.textContent = token.slice(2,-2); parent.appendChild(strong); }
    else { const id = token.slice(1,-1), ev = evidenceMap.get(id); if (ev) { const a=document.createElement('a'); a.href=ev.url; a.target='_blank'; a.rel='noopener noreferrer'; a.textContent=token; a.title=ev.title; a.style.cssText='color:var(--teal-deep);font-weight:800;text-decoration:none'; parent.appendChild(a); } else parent.appendChild(document.createTextNode(token)); }
    last = re.lastIndex;
  }
  if (last < text.length) parent.appendChild(document.createTextNode(text.slice(last)));
}
function renderSafeMarkdown(body, markdown, evidence) {
  const map = new Map((evidence||[]).map(e => [e.citationId,e]));
  const lines = String(markdown || '').split(/\r?\n/); let list = null;
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { list = null; continue; }
    if (line.startsWith('### ')) { const h=document.createElement('h3'); appendInline(h,line.slice(4),map); body.appendChild(h); list=null; continue; }
    if (line.startsWith('## ')) { const h=document.createElement('h3'); appendInline(h,line.slice(3),map); body.appendChild(h); list=null; continue; }
    if (/^[-*]\s+/.test(line)) { if (!list) { list=document.createElement('ul'); body.appendChild(list); } const li=document.createElement('li'); appendInline(li,line.replace(/^[-*]\s+/,''),map); list.appendChild(li); continue; }
    const p=document.createElement('p'); appendInline(p,line,map); body.appendChild(p); list=null;
  }
}
function renderSources(body, evidence) {
  if (!evidence?.length) return;
  const card=document.createElement('div'); card.className='card reveal';
  const head=document.createElement('div'); head.className='card-h'; head.innerHTML='<b>Sources used</b><span>Authoritative evidence retrieved for this answer</span>'; card.appendChild(head);
  const wrap=document.createElement('div'); wrap.style.padding='10px 18px 14px';
  evidence.forEach(e => { const a=document.createElement('a'); a.className='src'; a.href=e.url; a.target='_blank'; a.rel='noopener noreferrer'; a.style.textDecoration='none'; a.innerHTML=I.book; const span=document.createElement('span'); span.textContent=`${e.citationId} · ${e.publisher} — ${e.title}`; a.appendChild(span); wrap.appendChild(a); });
  card.appendChild(wrap); body.appendChild(card);
}
function mayaPreamble(userText, packet) {
  const low=String(userText||'').toLowerCase();
  if(packet?.safety?.mustEscalate) return '';
  if(/\b(who are you|what are you|your name|are you (?:a )?(?:doctor|human)|are you ai|real doctor)\b/i.test(low)) {
    return "I'm Maya, the AI medical-information specialist inside Rounds — not a human doctor.";
  }
  if(/\b(worried|scared|anxious|afraid|panic|terrified|nervous)\b/i.test(low)) {
    return "I can see why this would feel worrying. I’ll keep this clear and stick to what the evidence supports.";
  }
  if(/\b(medicine|medication|drug|tablet|capsule|dose|dosage|side effect|interaction|prescription)\b/i.test(low)) {
    return "I’ll keep this practical and separate general medication information from anything that needs a clinician or pharmacist to individualize.";
  }
  if(/\b(a1c|hba1c|blood test|lab|result|report|mri|ct scan|x-ray|xray|ultrasound)\b/i.test(low)) {
    return "I’ll translate this into plain English first, then separate what the result can show from what it cannot confirm on its own.";
  }
  if(/\b(symptom|pain|rash|dizzy|dizziness|fever|headache|cough|nausea|breathless|shortness of breath)\b/i.test(low)) {
    return "I’ll help you make sense of this without jumping to a diagnosis.";
  }
  return '';
}

function updateSummaryFromPacket(packet) {
  const level=uiLevel(packet), L=LEVELS[level];
  if (!S.top || L.rank >= LEVELS[S.top.level].rank) S.top={level,text:packet?.answer?.triageSummary || (packet?.safety?.mustEscalate ? packet.safety.emergencyText : 'Medical information retrieved from authoritative sources.')};
  const topic=displayTopic(packet); S.topics.push({name:topic,level,time:new Date().toLocaleTimeString([],{hour:'numeric',minute:'2-digit'})});
  (packet.evidence||[]).filter(e=>e.sourceId==='rxnorm'&&e.metadata?.name).forEach(e=>{if(!S.meds.includes(e.metadata.name))S.meds.push(e.metadata.name);});
  (packet.answer?.followUpQuestions||[]).forEach(q=>{if(q&&!S.qs.find(x=>x.q===q))S.qs.push({q,done:false});});
  (packet.evidence||[]).slice(0,8).forEach(e=>{const s=`${e.citationId} · ${e.publisher}`;if(!S.src.includes(s))S.src.push(s);});
  renderSummary();
}
async function askProductionMedicalAI(message) {
  const r=await fetch('/api/rounds-maya-query',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({message,audience,region:regionKey,contextDocuments:pendingDocuments.map(d=>({name:d.name,type:d.type,text:d.text||''}))})});
  if(!r.ok) throw new Error(`Medical service returned ${r.status}`);
  return r.json();
}
async function generate(text, redo) {
  const id=++gen; busy=true; setSend(); ECG.set('busy');
  const p={topic:'Medical answer',level:'info',steps:['Checking safety','Searching authoritative medical knowledge','Verifying evidence']};
  const {wrap,body}=aiShell(p); const m=monitor(body,p.steps);
  try {
    const packet=await askProductionMedicalAI(text); m.stop(); if(id!==gen){wrap.remove();return;}
    const level=uiLevel(packet), L=LEVELS[level], tri=wrap.querySelector('.tri');
    if(tri){tri.textContent=L.label;tri.style.setProperty('--c',L.c);tri.style.setProperty('--t',L.t);}
    wrap.querySelector('.ai-head b').textContent='Maya';
    const mayaIntro=mayaPreamble(text,packet);
    if(mayaIntro){const intro=document.createElement('p');intro.className='reveal';intro.textContent=mayaIntro;body.appendChild(intro);}
    renderSafeMarkdown(body,packet?.answer?.answerMarkdown || 'No answer was returned.',packet.evidence||[]);
    renderSources(body,packet.evidence||[]);
    finish(wrap,body,text);
    if(!redo) updateSummaryFromPacket(packet);
    pendingDocuments=[];
  } catch(error) {
    m.stop(); if(id!==gen){wrap.remove();return;}
    const note=document.createElement('div');note.className='note warn';note.innerHTML=`${I.warn}<div></div>`;note.querySelector('div').textContent='The medical knowledge service could not complete this request. No medical answer was generated. Please try again.';body.appendChild(note);
  }
  if(id===gen){busy=false;setSend();ECG.set('idle');follow();}
}
function send(text) {
  text=(text||'').trim(); if(!text||busy)return;
  startChat(text,'info'); addUser(text); input.value=''; autosize(); stick=true; follow(); generate(text);
}

/* ---------- Wiring ---------- */
const photoBtn=document.querySelector('.c-btn[aria-label="Add a photo"]');
const testBtn=document.querySelector('.c-btn[aria-label="Add test results"]');
const voiceBtn=document.querySelector('.icon-btn[aria-label="Voice input"]');
const fileInput=document.createElement('input');fileInput.type='file';fileInput.hidden=true;document.body.appendChild(fileInput);
async function attachFile(file,kind){
  if(!file)return;
  const ext=(file.name.split('.').pop()||'').toLowerCase();
  const textTypes=new Set(['txt','md','csv','json','log','xml','html']);
  if(textTypes.has(ext)||file.type.startsWith('text/')){
    const text=(await file.text()).slice(0,18000); pendingDocuments=[{name:file.name,type:file.type||'text/plain',text}]; toast(`${file.name} attached for this question`); return;
  }
  if(kind==='photo'){toast('Photo analysis is disabled until a validated medical-vision model is configured.');return;}
  if(ext==='pdf'){toast('PDF upload is recognized, but this safety build only extracts text/CSV results locally.');return;}
  toast('Use a text, CSV, JSON or similar text-based test result file for now.');
}
if(photoBtn)photoBtn.addEventListener('click',()=>{fileInput.accept='image/*';fileInput.dataset.kind='photo';fileInput.value='';fileInput.click();});
if(testBtn)testBtn.addEventListener('click',()=>{fileInput.accept='.txt,.md,.csv,.json,.log,.xml,.html,.pdf,text/*,application/pdf';fileInput.dataset.kind='test';fileInput.value='';fileInput.click();});
fileInput.addEventListener('change',()=>attachFile(fileInput.files?.[0],fileInput.dataset.kind));
if(voiceBtn)voiceBtn.addEventListener('click',()=>{
  const SR=window.SpeechRecognition||window.webkitSpeechRecognition;if(!SR){toast('Voice input is not supported in this browser');return;}
  const rec=new SR();rec.lang=navigator.language||'en-US';rec.interimResults=false;rec.maxAlternatives=1;rec.onresult=e=>{input.value=e.results[0][0].transcript;autosize();input.focus();};rec.onerror=()=>toast('Voice input could not start');rec.start();
});
input.addEventListener('input', autosize);
input.addEventListener('keydown', e => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); if (!busy) send(input.value); } });
sendBtn.addEventListener('click', () => { if (busy) { gen++; busy = false; setSend(); ECG.set('idle'); toast('Answer stopped'); } else send(input.value); });
$$('.aud button').forEach(b => b.addEventListener('click', () => {
  audience = b.dataset.aud;
  $$('.aud button').forEach(x => x.setAttribute('aria-checked', x === b));
  input.placeholder = audience === 'clinician' ? 'Ask about dosing, guidelines, or a clinical scenario' : 'Describe your symptoms or ask about a medicine';
}));
const toggleHist = open => { app.classList.toggle('hist-open', open); app.classList.remove('sum-open'); $('#railHist').setAttribute('aria-pressed', open); };
$('#railHist').addEventListener('click', () => toggleHist(!app.classList.contains('hist-open')));
$('#openHist').addEventListener('click', () => toggleHist(true));
$('#closeHist').addEventListener('click', () => toggleHist(false));
$('#railNew').addEventListener('click', newChat);
$('#newTop').addEventListener('click', newChat);
$('#railSum').addEventListener('click', () => {
  if (matchMedia('(max-width:1240px)').matches) { app.classList.add('sum-open'); app.classList.remove('hist-open'); return; }
  const hidden = app.style.gridTemplateColumns === '78px minmax(0px, 1fr) 0px';
  app.style.gridTemplateColumns = hidden ? '' : '78px minmax(0px, 1fr) 0px';
  $('#summary').style.display = hidden ? '' : 'none';
  $('#railSum').setAttribute('aria-pressed', hidden);
});
$('#openSum').addEventListener('click', () => { app.classList.add('sum-open'); app.classList.remove('hist-open'); });
$('#closeSum').addEventListener('click', () => app.classList.remove('sum-open'));
$('#scrim').addEventListener('click', () => { app.classList.remove('sum-open'); toggleHist(false); });
$('#search').addEventListener('input', e => { const q = e.target.value.toLowerCase(); $$('.hist').forEach(h => { h.style.display = h.textContent.toLowerCase().includes(q) ? '' : 'none'; }); });
document.addEventListener('keydown', e => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); newChat(); }
  if (e.key === 'Escape') { closeMenu(); app.classList.remove('sum-open'); toggleHist(false); }
});

const hr = new Date().getHours();
$('#greet').textContent = hr < 12 ? 'Good morning' : hr < 18 ? 'Good afternoon' : 'Good evening';
$('#sumDate').textContent = new Date().toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' });
renderRegionMenu(); renderTiles(); renderBody(); renderSummary(); setSend();
})();
